import * as React from 'react';

import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import { Flex, flameTheme } from '@lightspeed/flame/Core';
import { IconExternalLink } from '@lightspeed/flame/Icon/ExternalLink';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { PaddedCardSection, verticalAlign } from '../device.styles';

interface ButtonOptions {
  isVisible: boolean;
  isDisabled: boolean;
  label: string;
  variant: string;
  onClick: () => void;
  [key: string]: any;
}

interface Props {
  icon: React.ReactNode;
  title: string;
  body: React.ReactNode;
  link: {
    label: string;
    url: string;
    target?: string;
  };
  buttonOptions: ButtonOptions;
  status?: React.ReactNode;
}

const LinkButton = styled(Button)`
  color: white !important;
`;

const DeviceCard: React.FunctionComponent<Props> = ({
  icon,
  title,
  body,
  link,
  buttonOptions,
  status,
}) => {
  const { isVisible, isDisabled, label, variant, onClick, ...extraButtonOptions } = buttonOptions;
  const { space, colors, fontSizes } = flameTheme;
  return (
    <Card className="cr-mb-3">
      <PaddedCardSection>
        <Flex justifyContent="space-between">
          <Flex>
            {icon}
            <Flex ml={space[3] as any} flexDirection="column" alignItems="flex-start">
              <Flex alignItems="center">
                <Text mr={2} fontSize={fontSizes.text} color={colors['gray-850']} fontWeight="bold">
                  {title}
                </Text>
                {status || null}
              </Flex>
              <Text mb={1} color="gray">
                {body}
              </Text>
              <TextLink href={link.url} target={link.target}>
                <Flex alignItems="center">
                  <Text mr={1} fontWeight="bold">
                    {link.label}
                  </Text>
                  {link.label !== 'Learn more' ? (
                    <IconExternalLink
                      size={space[2] as string}
                      css={verticalAlign}
                      color={colors.secondary}
                    />
                  ) : null}
                </Flex>
              </TextLink>
            </Flex>
          </Flex>
          {isVisible ? (
            <Flex alignSelf="flex-start">
              <LinkButton
                data-test="device-card-button"
                disabled={isDisabled}
                variant={variant}
                fill
                onClick={onClick}
                {...extraButtonOptions}
              >
                {label}
              </LinkButton>
            </Flex>
          ) : null}
        </Flex>
      </PaddedCardSection>
    </Card>
  );
};

export { DeviceCard };
